const controller = function(component){
    var self = this;

    this.init = function(){
        component.ranking = {
            source: {},
            ranked: {},
            isMovable: {}
        };

        //Setup answers container
        self.clear();

        //Setup enable/disable switches
        var disabled = {};
        for(let g=0; g<component.question.config.groups.length; g++){
            var group = component.question.config.groups[g];

            disabled[group.id] = {};

            for(let i=0; i<group.inputs.length; i++){
                var input = group.inputs[i];
                disabled[group.id][input.id] = input.disabled ? true: false;
            }
        }
        component.disabled = disabled;      
        
        //Setup enable other
        self.clearOther();
    }

    this.setValue = function(group_id, valueArray){
        if( group_id && valueArray && typeof valueArray=='object' ){
            component.value[group_id] = valueArray;
            
            
            var ranked = [];
            for(let i=0; i<valueArray.length; i++){
                var value =valueArray[i];
                for(let i=0; i<component.ranking.source[group_id].length; i++){
                    var input = component.ranking.source[group_id][i];
                    if(input.value==value){
                        break;
                    }
                }
                ranked.push(input);
            }

            var source = [];
            for(let i=0; i<component.ranking.source[group_id].length; i++){
                var input = component.ranking.source[group_id][i];

                if(!component.$root.in_array(input.value,valueArray)){
                    source.push(input);
                }
            }            
            component.ranking.source[group_id] = source;
            component.ranking.ranked[group_id] = ranked;
        }else{
            console.error("setValue Error: ",{
                group_id: group_id,
                value: value
            })
        }
    }

    this.value_action = function(){
        return new Promise((resolve, reject)=>{            
            resolve();
        })
    }

    this.clear = function(group_id){
        if(group_id){
            var ranking = {};
            for(let g=0; g<component.question.config.groups.length; g++){
                var group = component.question.config.groups[g];
                component.ranking.isMovable[group.id] = true;
                ranking[group.id] = [];
                for(let i=0; i<group.inputs.length; i++){
                    var input = JSON.stringify(group.inputs[i]);
                    input = JSON.parse(input);
                    input.group_id = group.id;
                    
                    ranking[group.id].push(input);
                }
            }

            ranking = JSON.stringify(ranking);
            ranking = JSON.parse(ranking);

            component.ranking.source[group_id] = ranking[group_id];
            component.ranking.ranked[group_id] = [];
            component.value[group_id] = [];
            self.clearOther(group_id, value);
        }else{
            var ranking = {};
            var ranked = {};
            var value = {};
            for(let g=0; g<component.question.config.groups.length; g++){
                var group = component.question.config.groups[g];
                component.ranking.isMovable[group.id] = true;
                ranking[group.id] = [];
                ranked[group.id] = [];
                value[group.id] = [];
                for(let i=0; i<group.inputs.length; i++){
                    var input = group.inputs[i];
                    var input = JSON.stringify(group.inputs[i]);
                    input = JSON.parse(input);
                    input.group_id = group.id;

                    ranking[group.id].push(input);
                }
            }

            ranking = JSON.stringify(ranking);
            ranking = JSON.parse(ranking);

            component.ranking.source = ranking;
            component.ranking.ranked = ranked;
            component.value = value;
            self.clearOther();
        }
        
    }

    this.setDisable = function(state, group_id, input_id){
        var config = component.get_config(group_id, input_id);
        var value = config.input.value;
        if(state===true){
            self.clear(group_id, value);
        }
        component.disabled[group_id][input_id] = state;
    }

    this.clearOther = function(group_id, value){
        if(group_id && value){
            component.other[group_id][value] = null;
            component.enableOther[group_id][value] = false;
        }else{
            //Setup 'other' fields
            var other = {}
            var enableOther = {}
            for(let g=0; g<component.question.config.groups.length; g++){
                var group = component.question.config.groups[g];
    
                other[group.id] = {};
                enableOther[group.id] = {};
                for(let i=0; i<group.inputs.length; i++){
                    var input = group.inputs[i];
                    enableOther[group.id][input.id] = false;
                    other[group.id][input.id] = null;
                }
            }
            component.other = other;
            component.enableOther = enableOther;
        }
    }

    this.isMoveable = function(event){
        var group_id = event.draggedContext.element.group_id;
        var config = component.get_config(group_id);
        var type_config = config.group.type_config.Ranking;
        var max = component.value[group_id].length < type_config.max;

        return max;
    }

    this.validate = function(debug){
        var values = component.value;
        var configMap = component.get_configMap();
        var valid = true;

        let groups = component.question.config.groups;
        for(let g=0; g<groups.length; g++){
            let group = groups[g];
            let group_id = group.id;

            var config = configMap[group_id].group.type_config[component.question.config.type];
            var min = parseInt(config.min,10);
            var max = parseInt(config.max,10);

            var answers = values[group_id];
            var valid_group = min<=answers.length && answers.length<=max;

            if(valid_group===false){
                valid = false;
                break;
            }            
        }

        if(debug){
            console.log({
                'question_id': component.question.config.id,
                'type': component.question.config.type,
                'answers': values,
                'valid': valid
            })
        }

        return valid;
    }

    this.init();    
}

export default controller;